import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ControllersList } from 'components/Controllers/ControllersList';
import MDBox from 'components/MDBox';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'layouts/LayoutContainers/DashboardLayout';
import { useDispatch, useSelector } from 'react-redux';
import useCustomBackButtonHandler from '../../hooks/useCustomBackButtonHandler';

const ControllersListPage = () => {
  const dispatch = useDispatch();
  useCustomBackButtonHandler();
  return (
    <DashboardLayout>
      <DashboardNavbar objectName="Controllers list" />
      <Typography
        fontSize="11px"
        sx={{
          paddingLeft: { xs: 0, sm: '12px' },
          marginTop: { xs: '-15px', sm: '-5px' },
          textAlign: { xs: 'center', sm: 'left' },
        }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox pt={{ xs: 1 }} pb={1}>
        <Grid container>
          <Grid item xs={12}>
            <ControllersList />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default ControllersListPage;
